import React from "react";
import { Box, IconButton } from "@mui/material";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import IMG from "../assets/Signals.png";

const SignalsCard = () => {
  const signals = [
    {
      title: "High Utilization",
      signal:
        "The customer consistently uses more than 90% of their Working Capital credit limit. The customer has not defaulted on payments in past 1 year.",
      action:
        "Propose a credit line increase or discuss long-term financing solutions to reduce dependency on short-term credit",
    },
    {
      title: "Low Product Penetration",
      signal:
        "The customer uses only a limited set of banking products (e.g., deposits and working capital loans) compared to peers in the same industry",
      action:
        "Recommend complementary products (e.g., treasury solutions, trade finance)",
    },
    // {
    //   title: "Treasury Management Opportunities",
    //   signal: "The customer holds large cash balances in the Current Account without optimizing yield",
    //   action: "Suggest cash management or short-term investment products"
    // },
    {
      title: "Shift in Transaction Volume",
      signal:
        "The customer’s payment or trade transaction volumes from Current Account held at Bank has declined in last 6 months",
      action:
        "Engage the client to understand operational challenges and offer solutions",
    },
  ];

  const handleView = () => {};
  return (
    <Box
      className="rounded-md py-2 px-4"
      style={{
        boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.1)",
        height: "60vh",
        overflowY: "auto",
      }}
    >
      <div className="flex justify-between items-center">
        <div className="text-main font-bold text-left text-xs pb-4">
          Signals
        </div>
        <div className="text-xs text-gray-500 italic font-bold">
          | Illustrative |
        </div>
      </div>
      <ul className="list-none">
        {signals.map((item, index) => (
          <li key={index} className="mb-4">
            <div
              className="border rounded p-3"
              style={{ borderColor: "#A6A6A6" }}
            >
              <div className="text-main font-bold text-[10px]">
                {item.title}
              </div>
              <div className="text-gray-600 text-[10px]">
                <span className="font-semibold">Action: </span>
                {item.action}
              </div>
              <div className="text-gray-600 text-[10px] py-1">
                <span className="font-semibold">Reason Code: </span>
                {item.signal}
              </div>
            </div>
          </li>
        ))}
      </ul>
    </Box>
  );
};

export default SignalsCard;
